import React, { useEffect, useRef, useState } from "react";
import ModalContainer from "../../components/ModalContainer.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import { getTicketServiceContext, updateTicket } from "../../services/ticketsServices.js";
import { getTicketService } from "../../services/ticketsServices.js";
import TicketContext from "../../components/TicketContext.jsx";
import { convertDateToJalaali } from "../../utils/convertDate.js";
import Alert from "../../utils/Alert.js";
import { CircularProgress, IconButton } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { ErrorMessage, Form, Formik } from "formik";
import GetField from "../../components/GetField.jsx";
import {
  initialValues,
  onSubmit,
  validationSchema,
} from "../Tickets/contextFormikCodes.js";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FolderOffIcon from "@mui/icons-material/FolderOff";
import ShowError from "../../components/ShowError.jsx";

const ServiceTicketContext = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [contexts, setContexts] = useState([]);
  const [ticket, setTicket] = useState(null);
  const [fileName, setFileName] = useState("");
  const [sendSms, setSendSms] = useState(false)
  const [sendEmail, setSendEmail] = useState(false)
  const [closeTicket, setCloseTicket] = useState(false)
  const [data, setData] = useState({
    send_sms: false,
    send_email: false,
    status: "o"
  })

  const location = useLocation();
  const navigate = useNavigate();
  const contextListRef = useRef(null);
  const fileInputRef = useRef(null);
  const textareaContainerRef = useRef(null);

  const handleGetTicketContexts = async (servicecode) => {
    setIsLoading(true);
    try {
      const response = await getTicketServiceContext(servicecode);
      if (response.status === 200) {
        const allContexts = response.data.map((c) => ({
          ...c,
          date: convertDateToJalaali(c.sending_date, "jYYYY/jMM/jDD"),
          time: convertDateToJalaali(c.sending_date, "HH:mm"),
        }));
        setContexts(allContexts);
      }
    } catch (error) {
      Alert(
        `خطا ${error.response?.status || ""}!`,
        "در دریافت پیام‌ها مشکلی رخ داده است!\nلطفاً مجدداً تلاش کنید.",
        "error"
      );
      return navigate(-1);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateTicket = async (ticketCode, data) => {
    setIsLoading(true);
    try {
      const response = await updateTicket(ticketCode, data);
    } catch (error) {
      Alert(
        `خطا ${error.response?.status || ""}!`,
        "در دریافت پیام‌ها مشکلی رخ داده است!\nلطفاً مجدداً تلاش کنید.",
        "error"
      );
      return navigate(-1);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetTicket = async (servicecode) => {
    setIsLoading(true);
    try {
      const response = await getTicketService(servicecode);
      if (response.status === 200) {
        const ticket = response.data;
        setTicket(ticket);
        setSendEmail(ticket.send_email)
        setSendSms(ticket.send_sms)
        setCloseTicket(ticket.status === "c" ? true : false)
      }
    } catch (error) {
      Alert(
        `خطا ${error.response?.status || ""}!`,
        "در دریافت تیکت مشکلی رخ داده است!\nلطفاً مجدداً تلاش کنید.",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeFile = (ev, formik) => {
    const file = ev.target.files[0];
    if (!file) return;
    formik.setFieldValue("file", file);
    setFileName(file.name);
  };

  async function handleChangeSms() {  
    const newValue = !sendSms; 
    setSendSms(newValue);  
    Alert("انجام عملیات", "تیکت با موفقیت ویرایش شد", "success");  
    
    const newData = {  
        ...data,   
        send_sms: newValue,  
        send_email: sendEmail,   
        status: closeTicket ? "c" : "a"  
    };  
    setData(newData);  

    await handleUpdateTicket(ticket.code, newData);
  }

  async function handleChangeEmail() {
    const newValue = !sendEmail
    setSendEmail(newValue);
    Alert("انجام عملیات", "تیکت با موفقیت ویرایش شد", "success");

    const newData = {  
      ...data,   
      send_sms: sendSms,  
      send_email: newValue,   
      status: closeTicket ? "c" : "a"  
    };  
    setData(newData);  

    await handleUpdateTicket(ticket.code, newData);
  }

  async function handleChangeCloseTicket() {
    const newValue = !closeTicket
    setCloseTicket(newValue)
    Alert("انجام عملیات", "تیکت با موفقیت ویرایش شد", "success");

    const newData = {  
      ...data,   
      send_sms: sendSms,  
      send_email: sendEmail,   
      status: newValue ? "c" : "a"  
    };  
    setData(newData);  

    await handleUpdateTicket(ticket.code, newData);
  }

  const handleRemoveFile = (formik) => {
    formik.setFieldValue("file", "");
    setFileName("");
  };

  useEffect(() => {
    if (location.state) {
      handleGetTicketContexts(location.state.code);
      handleGetTicket(location.state.code);
    } else {
      return navigate(-1);
    }
  }, []);

  useEffect(() => {
    if (contextListRef && contextListRef.current && contexts.length > 0) {
      contextListRef.current.scrollTop = contextListRef.current.scrollHeight;
    }
  }, [contextListRef, contexts]);

  return (
    <ModalContainer
      alwaysOpen={true}
      fullscreen={true}
      title={`موضوع: ${ticket?.subject}`}
    >
      <div
        ref={contextListRef}
        className={`w-full scroll-smooth 
                absolute right-0 overflow-auto 
                px-5 pt-6 dir-ltr children-dir-rtl
                ${
                  ticket?.status === "o" || ticket?.status === "a"
                    ? "context-list-open bottom-40"
                    : "context-list-closed bottom-0"
                }`}
      >
        {isLoading ? (
          <div
            className="w-full flex flex-col 
                    items-center justify-center
                    px-3 py-10"
          >
            <CircularProgress size={40} />
            <span
              className="text-primary mt-4 
                        text-lg opacity-animation"
            >
              صبر کنید...
            </span>
          </div>
        ) : (
          contexts.map((c, index) => (
            <div
              key={`context_${index}`}
              className={`w-full mb-5 flex
                            ${
                              c.sender === "a" ? "justify-start" : "justify-end"
                            }`}
            >
              <TicketContext
                context={c.context}
                date={c.date}
                time={c.time}
                code={c.code}
                file={c.file}
                className={`context-item ${
                  c.sender === "a" ? "bg-blue-400" : "bg-gray-300"
                }`}
              />
            </div>
          ))
        )}
      </div>
      {(ticket?.status === "o" || ticket?.status === "a") && (
        <Formik
          initialValues={initialValues}
          onSubmit={(values, actions) => {
            onSubmit(
              values,
              actions,
              ticket,
              setContexts,
              setFileName,
              textareaContainerRef
            );
            }
          }
          validationSchema={validationSchema}
          validateOnMount
        >
          {(formik) => {
            return (
              <Form
                className="absolute bottom-0 
                            right-0 w-full h-40 flex flex-row 
                            items-center px-4 py-1 bg-white 
                            border-t-2 border-black overflow-hidden"
              >
                <div className="flex-1" ref={textareaContainerRef}>
                  <div className="flex items-center space-x-3 mb-2">  
                      <div className="flex items-center">  
                        <input  
                          id="send-email"  
                          type="checkbox"  
                          checked={sendEmail} 
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"  
                          onChange={handleChangeEmail}
                        />  
                        <label htmlFor="send-email" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">  
                          ارسال ایمیل  
                        </label>  
                      </div>  
                      
                      <div className="flex items-center p-4">  
                        <input    
                          id="send-sms"  
                          type="checkbox"  
                          checked={sendSms}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"  
                          onChange={handleChangeSms}  
                        />  
                        <label htmlFor="send-sms" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">  
                          ارسال پیامک  
                        </label>  
                      </div>  

                      <div className="flex items-center p-0">  
                        <input    
                          id="close-ticket"  
                          type="checkbox"  
                          checked={closeTicket}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"  
                          onChange={handleChangeCloseTicket}  
                        />  
                        <label htmlFor="close-ticket" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">  
                          اتمام تیکت  
                        </label>  
                      </div>  
                    </div>  
                  <GetField
                    control="textarea"
                    name="context"
                    placeholder="متن خود را وارد کنید..."
                    rows={2}
                    unresizable={true}
                    unshownError={true}
                    className="relative"
                    fieldClass="pe-12 py-1.5"
                    autoFocus={true}
                  >
                    <IconButton
                      onClick={() => fileInputRef.current.click()}
                      sx={{
                        position: "absolute",
                        left: "1.3rem",
                        top: "0",
                        bottom: "0",
                        my: "auto",
                        width: "30px",
                        height: "30px",
                      }}
                    >
                      <AttachFileIcon
                        sx={{
                          fontSize: "1.3rem",
                          rotate: "45deg",
                        }}
                        color="primary"
                      />
                    </IconButton>
                  </GetField>
                  <input
                    type="file"
                    ref={fileInputRef}
                    className="hidden"
                    onChange={(ev) => handleChangeFile(ev, formik)}
                  />
                  {fileName && (
                    <>
                      <div
                        className="w-full mt-2 
                                            flex items-center 
                                            text-sm break-all"
                      >
                        <span
                          onClick={() => handleRemoveFile(formik)}
                          className="cursor-pointer"
                          title="حذف فایل"
                        >
                          <FolderOffIcon
                            sx={{
                              fontSize: "1.25rem",
                              ml: "0.25rem",
                            }}
                            color="error"
                          />
                        </span>
                        {fileName}
                      </div>
                      <ErrorMessage name="file" component={ShowError} />
                    </>
                  )}
                </div>
                <div className="rotate-180 pe-4">
                  {formik.isSubmitting ? (
                    <CircularProgress size={25} />
                  ) : (
                    <IconButton
                      disabled={
                        formik.values.file === "" &&
                        formik.values.context.trim() === ""
                      }
                      onClick={() => formik.submitForm()}
                    >
                      <SendIcon
                        color={
                          formik.values.file === "" &&
                          formik.values.context.trim() === ""
                            ? "disabled"
                            : "primary"
                        }
                      />
                    </IconButton>
                  )}
                </div>
              </Form>
            );
          }}
        </Formik>
      )}
    </ModalContainer>
  );
};

export default ServiceTicketContext;
